import { useSettings } from "~/store/settings";

export default async function initialiseVertical() {
	const stickyVerticalCookie = useCookie("sticky-vertical");
	const route = useRoute();
	const store = useSettings();
	const router = useRouter();

	if (store.isDataFree) return;
	if (store.isNativeApp && store.isSynapseV2) return;

	return await new Promise<void>((resolve) => {
		if (stickyVerticalCookie.value && stickyVerticalCookie.value !== route.fullPath && !route.query.bookingCode && route.path === "/") {
			router.push({ path: stickyVerticalCookie.value, query: route.query }).then(() => {
				resolve();
			});
		} else {
			resolve();
		}
	});
}
